import { defineMessages } from 'react-intl';

export const agentTimelineMessages = defineMessages({
  turnCancelled: {
    defaultMessage: 'Turn canceled',
    id: 'U1M6r0DESk',
    description: 'Inline marker when the user canceled an agent turn',
  },
  promptContextFailed: {
    defaultMessage: 'Prompt context failed.',
    id: 'dXQASznAl0',
    description: 'Fallback line when prompt context loading fails without detail',
  },
});
